import React, { useRef, useEffect } from "react";
import * as d3 from 'd3';
import { select } from 'd3';
import axios from 'axios'
import { useQuery } from 'react-query'

const fetchData = async (menuKey) => {
    const { data } = await axios.get(`${process.env.REACT_APP_API_HOST}/bc/svc/1${menuKey}`);
    // console.log(data);
    return data;
}

function DataContainerArea(props) {
    const { SelectedPrevYear, SelectedAreaInfo, handleAreaNumber, Color, menu, menuKey } = props;
    const { data, error, isError, isLoading } = useQuery(['dataArea', menuKey], () => fetchData(menuKey));
    const svgRef = useRef(null); //svgRef 로 DOM 조작함.
    // SelectedPrevYear: 선택된 이전연도, SelectedNextYear: 선택된 이후연도, data: fetching data
    // console.log(SelectedPrevYear, SelectedAreaInfo, data, 'data')
    // windowDimensions: width, height
    // console.log(windowDimensions, 'windowDimensions')

    const totalName = '대한민국';
    const tcolor = Color, grey = '#EEE';
    const ms = 9, margin = 5, legendMargin = 30;
    const chartWidth = 150 - margin * 2;
    const chartHeight = 150 - margin * 2;
    // const svgTs = d3.select('div.ts').append('svg'); // 변수명 svg 로 정의함.
    const sdname = SelectedAreaInfo.SD, sggname = SelectedAreaInfo.SG;

    function preprocess(data, sdname, sggname = null) {

        // console.log('data',data)
        // console.log('data[sdname]',data[sdname])
        // console.log('sdname / sggname',sdname, sggname)

        // const d = sggname !== null ? data[sdname][sggname] : data[sdname]['대한민국'];

        //let NaN_years = ['2015','2016','2017','2018','2019','2020','2021']
		let NaN_years = ['2016','2017','2018','2019','2020','2021','2022','2023','2024']

        let d

        if (sggname !== null) {

            if (data[sdname]) {
                d = data[sdname][sggname]
            } else {
                d = []
                for (let y of NaN_years) {
                    d.push({
                        "year": new Date(y, 0),
                        "value": 0
                    })
                }
            }

        } else {
            d = data[sdname]['대한민국']
        }

        // console.log('d',d)

        if (d !== undefined) {
            for (let i of d) {
                i.value = +i.value || NaN;
                i.year = new Date(i.year);
            }
            return d;
        } else {
            console.log('d in undefined')
        }

    }

    function renderDotChart(data_, svg, sdname, sggname) {
        // const latestYear = yearList[yearList.length - 1].value;
        const selectedYear = SelectedPrevYear;
        // console.log(SelectedPrevYear)
        const data_tot = preprocess(data_, totalName);
        // console.log(data_tot)
        const totArea = data_tot.find(d => d.year.getFullYear() == selectedYear) ? data_tot.find(d => d.year.getFullYear() == selectedYear).value : 0;
        // console.log(totArea)
        let locArea = 0;
        if (sdname !== totalName) {
            const data_loc = preprocess(data_, sdname, sggname);
            // console.log('data_loc',data_loc)
            if (data_loc !== undefined)
                locArea = data_loc.find(d => d.year.getFullYear() == selectedYear) ? data_loc.find(d => d.year.getFullYear() == selectedYear).value : 0;
        } else {
            locArea = totArea;
        }

        const colorDots = locArea / totArea < .01 ? 1 : Math.round(100 * locArea / totArea);
        const greyDots = 100 - colorDots;
        handleAreaNumber(locArea, totArea)
        // console.log(colorDots, greyDots);

        const chart = svg.append('g')
            .attr('transform', `translate(${margin}, ${margin})`)
            .selectAll('rect')
            .data(d3.range(100))
            .join('rect')
            .attr('fill', (d, i) => i + 1 <= colorDots ? tcolor : grey)
            .attr('width', ms)
            .attr('height', ms)
            .attr('rx', ms / 4)
            .attr('x', (d, i) => i % 10 * ((chartWidth + ms) / 10))
            .attr('y', (d, i) => ((i / 10) >> 0) * ((chartHeight + ms) / 10));

        svg.append('g')
            .attr('transform', `translate(${chartWidth + legendMargin}, ${chartHeight / 4 + 18})`)
            .append('text')
            .text((locArea / totArea * 100).toFixed(2) + '%')
            .attr('fill', tcolor)
            .attr('class', 'dotChartPct');

        svg.append('g')
            .attr('transform', `translate(${chartWidth + legendMargin}, ${chartHeight / 2 + 14})`)
            .selectAll('text')
            .data([locArea, totArea])
            .join('text')
            .text(d => d.toFixed(1) + '㎢')
            .attr('class', 'dotChartLegend')
            // .attr('text-anchor', 'end')
            .attr('fill', (d, i) => i > 0 ? grey : tcolor)
            .attr('y', (d, i) => i > 0 ? 28 : 0);

        return chart;
    }

    useEffect(() => {
        const svg = select(svgRef.current); // selection 객체

        if (data && data !== undefined) {
            svg.selectAll('*').remove() //이전 svg 제거
            renderDotChart(data, svg, sdname, sggname);
        }
    }, [data, SelectedAreaInfo, SelectedPrevYear, menu]); //data 변경시 렌더링함.

    if (isLoading) {
        return <div></div>
    }
    if (isError) {
        return <div>Error! {error.message}</div>
    }

    return (
        <>
            {/* <svg ref={svgRef}></svg> */}
        </>
    );
}

export default DataContainerArea
